const BASE =
  "https://static.prod-images.emergentagent.com/jobs/9991af4a-e079-4bd9-9ef7-d6a9679360a7/images/";

export const IMAGES = {
  heroKasgari: BASE + "772cf8cadd405d36ecfda0bd370da9aee1af37a941090c91cb4190adb00d3211.jpeg",
  steppeHorsemen: BASE + "c5f8432910ce8cb72f8a1ed7af6158b6636bd7ab330816e632841557708fc72a.jpeg",
  yurtCamp: BASE + "c2db3da70d91803979147b18452d6037c5840077d39dcb120951bd60b69f5b1f.jpeg",
  silkRoad: BASE + "98faf92d1f6fc443735bbcf075430db5b4ac06ca4b36c40c139487bf3d6fcc38.jpeg",
  turkicAlp: BASE + "2eb17dbcbbe2188c281170cd529495cc19af8f87270929baaf4605d054196cc7.jpeg",
  ozanBard: BASE + "73ba07f04605744d3e2a7a02baae570537f93c4bd5ba17e4534bf0505d8d9919.jpeg",
  eagleHunter: BASE + "8862bf96d206a29a7b45579fc51a112554033042256d3959a41ebf460db03f4f.jpeg",
  historicMap: BASE + "861aaaa515089bb10b981927e7397078b20fd74ab2a50d361ad35e5eb24ef69e.jpeg",
};
